<div class="modal-header border-top-5-gray">

    <h5 class="modal-title">{{'CourtEventNoteSave.Title' | translate}} </h5>
</div>
<div class="modal-body bay-club-light-blue-2-bg">
    <bcu-local-spinner [size]="40" [visible]="(isFormLoading$ | async).visible"
        *ngIf="(isFormLoading$ | async).visible">
    </bcu-local-spinner>

    <form [formGroup]="form" novalidate *ngIf="form && !(isFormLoading$ | async).visible"
        ngxsForm="cbCourtEventNoteSave.form">

        <div>
            <label class="mb-1 dark-grey">{{'CourtEventNoteSave.Note' | translate}}</label>
            <div>
                <textarea rows="3" placeholder="{{'CourtEventNoteSave.WriteHere' | translate}}" class="form-control"
                    [formControl]="form.controls.note" maxlength="2000"></textarea>
            </div>
        </div>
    </form>

</div>

<div class="modal-footer">
    <div class="d-flex justify-content-end">
        <button type="button" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()"
            class="btn btn-light-blue-outline btn-sm">{{'General.Cancel' | translate}}</button>

        <button type="button" (click)="onSave()" [disabled]="!(isFormValid$ | async)"
            class="btn btn-light-blue btn-sm ml-2">{{'General.Save' | translate}}</button>
    </div>
</div>